import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  dogName: string;
  dogAge: number;
  dogBreed: string;
  testimonial: string;
}
export function TestimonialCard({
  name,
  dogName,
  dogAge,
  dogBreed,
  testimonial
}: TestimonialCardProps) {
  return <div className="bg-purple-50 rounded-lg p-6 border border-purple-100 shadow-sm" data-id="element-282">
      <div className="flex items-start mb-4" data-id="element-283">
        <QuoteIcon className="h-8 w-8 text-purple-400 mr-2" data-id="element-284" />
        <div data-id="element-285">
          <h3 className="font-bold text-lg" data-id="element-286">
            {dogName}, {dogAge}-year-old {dogBreed}
          </h3>
        </div>
      </div>
      <p className="text-lg italic mb-4" data-id="element-287">"{testimonial}"</p>
      <p className="text-right font-medium" data-id="element-288">- {name}</p>
    </div>;
}